define('controller/template/template.list.controller',['require','exports','module','fukit','view/template/template.list.page','model/template.model','fukit','model/lock.model','model/person.model','fukit'],function(require, exports, module) {
  //prettier-ignore
  var BaseController          = require('fukit').BaseController,
      TemplateListPage        = require('view/template/template.list.page'),
      TemplateModel           = require('model/template.model'),
      ResourceQueryCollection = require('fukit').ResourceQueryCollection,
      LockModel               = require('model/lock.model'),
      PersonModel             = require('model/person.model'),
      ROLES                   = require('fukit').Roles;

  var TemplateListController = BaseController.extend({
    radioRequests: {
      'controllers TemplateListController': '@constructor',
    },

    pageView: TemplateListPage,

    stateConfiguration: {
      defaults: {
        roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS],
      },
    },

    resources: {
      templateCollection: {
        collection: ResourceQueryCollection.extend({
          query: {
            select: [
              { from: 'Template.*' },
              { from: 'Lock.createDate', as: 'lockCreateDate' },
              { from: 'Person.firstName', as: 'lockUserFirstName' },
              { from: 'Person.lastName', as: 'lockUserLastName' },
            ],
            resourceClass: TemplateModel.Collection,
            as: 'Template',
            join: [
              {
                resourceClass: LockModel.Collection,
                joinType: 'leftOuterJoin',
                as: 'Lock',
                on: {
                  templateId: 'Template.id',
                },
              },
              {
                resourceClass: PersonModel.Collection,
                joinType: 'leftOuterJoin',
                as: 'Person',
                on: {
                  userAccountId: 'Lock.ownerUserId',
                },
              },
            ],
          },
        }),
        sort: {
          field: 'templateType.description',
        },
        //TODO: this should be switched to auto handling using the header
        // (switch when back end productization is ready)
        filters: [
          {
            field: 'productName',
            value: 'COI',
          },
        ],
      },
    },

    onStart: function() {
      this.fetchResource('templateCollection');
    },
  });

  module.exports = TemplateListController;
});

